import "./MainCard.css";

const beef = process.env.PUBLIC_URL + "/beef.mov";

function MainCard({ lang, setLang }) {
  return (
    <div className="main-card">
      <video
        className="main-card-bg-video"
        src={beef}
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
          left: 0,
          top: 0,
        }}
      />
      <div
        className="main-card-overlay"
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.6)",
          zIndex: 1,
          left: 0,
          top: 0,
        }}
      />
      <div
        className="main-card-content"
        style={{
          position: "relative",
          zIndex: 2,
          textAlign: "center",
        }}
      >
        <h2 className="main-card-title">Charleston Empanadas</h2>
        <p className="main-card-description">
          {lang === "es"
            ? "Sirviendo auténticas empanadas dominicanas y mas en el Lowcountry."
            : "Food trailer serving authentic Dominican empanadas and more in the lowcountry."}
        </p>
        <div className="main-card-buttons">
          <button
            style={{
              fontFamily: "'Open Sans', sans-serif",
              marginTop: "0",
              padding: "10px 24px",
              fontSize: "1rem",
              borderRadius: "6px",
              border: "none",
              fontWeight: "bold",
              background: "#fff",
              color: "#222",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            }}
            onClick={() => setLang(lang === "es" ? "en" : "es")}
          >
            {lang === "es" ? "Speak English?" : "¿Hablas Español?"}
          </button>
          <button
            style={{
              fontFamily: "'Open Sans', sans-serif",
              marginTop: "0",
              padding: "10px 24px",
              fontSize: "1rem",
              borderRadius: "6px",
              border: "none",
              fontWeight: "bold",
              background: "#FE6B45",
              color: "white",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              textDecoration: "none",
              display: "inline-block",
            }}
            onClick={() =>
              window.open(
                lang === "es" ? "/menu-es.pdf" : "/menu-en.pdf",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            {lang === "es" ? "Nuestro Menú" : "Our Menu"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default MainCard;
